<template>
  <div id="tags-view-container" class="tags-view-container">
    <div class="btn_pre el-icon-arrow-left"  @click="btnPre"></div>
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        {{ generateTitle(tag.title) }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">{{ $t('tagsView.refresh') }}</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">{{ $t('tagsView.close') }}</li>
      <li @click="closeOthersTags">{{ $t('tagsView.closeOthers') }}</li>
      <li @click="closeAllTags(selectedTag)">{{ $t('tagsView.closeAll') }}</li>
    </ul>
    <div class="btn_next el-icon-arrow-right" @click="btnNext"></div>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import { generateTitle } from '@/utils/i18n'
import path from 'path'
import Cookies from 'js-cookie'
import { getUserType } from '@/api/overseas'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route() {
      console.log(this.$route)
      console.log(this.$store.state.tagsView.visitedViews)
      if(this.NowRoute){
        //用于返回上次页面的路由
        this.preRoute = this.NowRoute
      }
      this.NowRoute = this.$route;
      this.addTags()
      this.moveToCurrentTag()
      if(this.$store.state.tagsView.visitedViews.length > 9){
        this.$confirm('最多打开8个菜单!', '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let index =this.$store.state.tagsView.visitedViews.length;
          this.$store.state.tagsView.visitedViews.splice(index-1,1);
          index =this.$store.state.tagsView.visitedViews.length;
          if(this.preRoute){
            this.$router.push(`${this.preRoute.fullPath}`);
          }else{
            this.$router.push(`${this.$store.state.tagsView.visitedViews[index-1].fullPath}`);
          }
        }).catch(() => {
          //捕捉到错误返回首页
          this.$router.push("/dashboard");
        });
      }
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
    this.refreshWindow()
  },
  methods: {
    /* 判断用户类型 */
    userType(){
         var userId =JSON.parse(localStorage.getItem("userInfo")).userId
        var userTypeParm ={
          sysUserId: userId
        }
          getUserType(userTypeParm).then(res => {
          if(res.records==='2'){
            return 2
          }
           if(res.records==='13'){
             return 13
              }
        })
    },
    refreshWindow() {
      window.addEventListener('beforeunload', this.beforeunloadHandler, false)
    },
    beforeunloadHandler() {
      Cookies.set('refreshWindow', 1)
    },
    generateTitle, // generateTitle by vue-i18n
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
        var userType = this.userType()
        if(userType === 2 && route.name!=="overseasWelcome"){
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
           }
        if(userType === 13 && route.name!=="Dashboard"){
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
           }
          /* const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          }) */
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      console.log(this.$route)
      console.log(this.$store.state.tagsView.visitedViews)
      const { name } = this.$route
      console.log(name)
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    },
    btnPre() {
      if (this.$refs['scrollPane'].$refs['scrollContainer'].wrap.scrollLeft <= 100000) {
        this.$refs['scrollPane'].$refs['scrollContainer'].wrap.scrollLeft += 100;
      }
    },
    btnNext() {
      if (this.$refs['scrollPane'].$refs['scrollContainer'].wrap.scrollLeft >= 0) {
        this.$refs['scrollPane'].$refs['scrollContainer'].wrap.scrollLeft -= 100;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 35px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background: #fff;
  // border-bottom: 1px solid #d8dce5;
  /*box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);*/
  transition: all 0.28s;
  ::v-deep.el-scrollbar__wrap {
    height: 52px !important;
  }
  ::v-deep.el-scrollbar__view {
    height: 100%;
/*     overflow: auto;
    ::-webkit-scrollbar{
      height: 3px !important;
    } */
  }
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 31px;
      // width: 85px;
      line-height: 31px;
      // border: 1px solid #d8dce5;
      // color: #495060;
      // background: #fff;
       color: #2D2D31;
background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 227, 245, 1);

      border-bottom: none;
      /*border-color: #42b983;*/
      // border: 1px solid #DCDFD4;
      /*padding: 0 8px;*/
      padding: 0 4px 0 16px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      text-align: center;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;

      &:first-of-type {
        /*margin-left: 15px;*/
        // margin-left: 15px;
        margin-left: 4px;
        padding-right: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        /*background-color: #42b983;*/
        // background-color: #4582be;


            color: #2E88FF;
        /*border-color: #42b983;*/
        // border: 1px solid #DCDFD4;


        background: rgba(244, 246, 250, 1);
        height: 31px;
          // width: 85px;

        border: none;
        /*&::before {*/
        /*  content: '';*/
        /*  background: #fff;*/
        /*  display: inline-block;*/
        /*  width: 8px;*/
        /*  height: 8px;*/
        /*  border-radius: 50%;*/
        /*  position: relative;*/
        /*  margin-right: 2px;*/
        /*}*/
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 18px;
      height: 18px;
      font-size: 18px;
      /*vertical-align: 2px;*/
      vertical-align: -2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
        /*vertical-align: -3px;*/
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
.btn_pre,.btn_next {
  color: #ffffff;
  cursor: pointer;
}
</style>
